(function () {
  'use strict';

  if (window.AxiomFreeShippingBar) return;

  var selector = '[data-free-shipping-bar]';
  var latestCart = null;
  var initialCartRequest = null;

  function formatMoney(cents) {
    var formatted;
    if (window.Axiom && typeof window.Axiom.formatMoney === 'function') {
      formatted = window.Axiom.formatMoney(cents);
    } else {
      return String(cents);
    }

    var moneyFormat = String(window.Axiom.moneyFormat || '{{amount}}');
    var placeholder = (moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    if (placeholder.indexOf('no_decimals') !== -1) return formatted;

    var decimalSeparator = placeholder === 'amount_with_comma_separator' || placeholder === 'amount_with_space_separator'
      ? ','
      : '.';
    var escapedSeparator = decimalSeparator === '.' ? '\\.' : ',';
    return formatted.replace(new RegExp(escapedSeparator + '00(?=\\D|$)'), '');
  }

  function replaceAmount(template, amount) {
    return String(template || '').split('{amount}').join(amount);
  }

  function cartTotalCents(cart) {
    if (!cart) return 0;

    // The Standard Cart API exposes money as cost.totalAmount.amount in major
    // currency units, while the Ajax Cart API exposes total_price in cents.
    // Normalize both documented response shapes before calculating progress.
    if (cart.cost && cart.cost.totalAmount && cart.cost.totalAmount.amount != null) {
      var amount = Number(cart.cost.totalAmount.amount);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }

    var totalPrice = Number(cart.total_price);
    return Number.isFinite(totalPrice) ? totalPrice : 0;
  }

  // Theme settings hold the threshold in the store currency. Cart totals are in
  // the shopper's currency, so convert with the rate Shopify exposes for it.
  function thresholdInCartCurrency(instance) {
    var threshold = Number(instance.dataset.thresholdCents || 0);
    var currency = window.Shopify && window.Shopify.currency;
    var storeCurrency = instance.dataset.thresholdCurrency || '';
    if (!currency || !currency.active || !storeCurrency || currency.active === storeCurrency) return threshold;
    var rate = Number(currency.rate);
    return rate > 0 ? Math.round(threshold * rate) : threshold;
  }

  function updateLiveRegion(instances) {
    var liveInstance = instances.find(function (instance) {
      return instance.closest('[data-quick-view-modal][aria-hidden="false"]');
    }) || instances.find(function (instance) {
      return instance.getClientRects().length > 0;
    }) || null;

    instances.forEach(function (instance) {
      var message = instance.querySelector('[data-free-shipping-message]');
      if (!message) return;
      message.setAttribute('aria-live', instance === liveInstance ? 'polite' : 'off');
    });
  }

  function updateInstance(instance, cart) {
    if (!instance || !cart) return;

    var threshold = thresholdInCartCurrency(instance);
    if (threshold <= 0) return;

    var total = Math.max(0, cartTotalCents(cart));
    var remaining = Math.max(0, threshold - total);
    var progress = Math.min(100, Math.max(0, total / threshold * 100));
    var reached = total >= threshold;
    var message = instance.querySelector('[data-free-shipping-message]');
    var progressbar = instance.querySelector('[data-free-shipping-progress]');
    var template = reached
      ? instance.dataset.successTemplate
      : instance.dataset.progressTemplate;

    if (message) {
      message.innerHTML = reached ? String(template || '') : replaceAmount(template, formatMoney(remaining));
    }

    instance.style.setProperty('--free-shipping-progress', progress + '%');
    if (progressbar) progressbar.setAttribute('aria-valuenow', String(Math.round(progress)));
  }

  function updateAll(cart, scope) {
    if (cart) latestCart = cart;
    if (!latestCart) return;

    var root = scope && scope.querySelectorAll ? scope : document;
    var instances = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) instances.unshift(root);

    instances.forEach(function (instance) {
      updateInstance(instance, latestCart);
    });
    updateLiveRegion(Array.prototype.slice.call(document.querySelectorAll(selector)));
  }

  function requestInitialCart() {
    if (latestCart) return Promise.resolve(latestCart);
    if (initialCartRequest) return initialCartRequest;
    if (!window.AxiomStandardStorefront || typeof window.AxiomStandardStorefront.getCart !== 'function') {
      return Promise.resolve(null);
    }

    initialCartRequest = window.AxiomStandardStorefront.getCart()
      .then(function (cart) {
        if (cart) updateAll(cart);
        return cart;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        initialCartRequest = null;
      });

    return initialCartRequest;
  }

  function initialize(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var hasInstance = Boolean(
      (root.matches && root.matches(selector)) || root.querySelector(selector)
    );
    if (!hasInstance) return;

    if (latestCart) {
      updateAll(latestCart, root);
      return;
    }
    requestInitialCart();
  }

  function handleCartEvent(event) {
    if (!event || !event.promise || typeof event.promise.then !== 'function') return;
    event.promise.then(function (result) {
      if (result && result.cart) updateAll(result.cart);
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialize(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
  document.addEventListener('shopify:cart:lines-update', handleCartEvent);
  document.addEventListener('shopify:cart:note-update', handleCartEvent);
  document.addEventListener('shopify:cart:discount-update', handleCartEvent);
  // Re-rendered cart markup comes from Liquid, which leaves a converted threshold empty.
  document.addEventListener('cart:drawer:rendered', function (event) {
    updateAll(null, event.detail && event.detail.drawer);
  });
  document.addEventListener('cart:page:rendered', function (event) {
    updateAll(null, event.detail && event.detail.cartPage);
  });

  window.AxiomFreeShippingBar = {
    initialize: initialize,
    update: updateAll
  };
})();
